import './login.scss';

import { UserAuthenticatedResult } from '@skinsoft/auth';
import { fetch } from '@skinsoft/network';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { FORM_ERROR } from 'final-form';
import { get } from 'lodash';
import { race } from 'rxjs';
import { first, map, mapTo } from 'rxjs/operators';
import { defineComponent } from 'vue';

import { router, Routes } from '../../../router';
import { LoginForm } from '../../component/login-form';

export const Login = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sLoginForm: LoginForm,
    },
    template: require('./login.html'),
    methods: {
        async onSubmit(values: Record<'username' | 'password', string>) {
            await this.$authService.logIn(values.username, values.password);

            const success$ = this.$authService.waitFor$('authenticated').pipe(mapTo(null));
            const error$ = this.$authService.waitFor$('unauthenticated').pipe(
                map(value => {
                    const [, event] = value;
                    const error = get(event, 'query.error', null);

                    if (!error) {
                        return null;
                    }

                    return {
                        [FORM_ERROR]: fetch.isNetworkError(error)
                            ? 'auth.login.error.network'
                            : 'auth.login.error.credentials',
                    };
                }),
            );

            return await race(success$, error$)
                .pipe(first())
                .toPromise();
        },
        onUser(user: UserAuthenticatedResult | null) {
            if (user?.user) {
                router.push({ name: Routes.HOME });
                return;
            }
        },
    },
    created() {
        this.subscribeTo(this.$authService.user$, this.onUser);
    },
})
